<template>
  <a
    :class="`page-quick-view__link ${key}__link`"
    @click="openModal"
    v-text="title"
  />

  <overlay
    ref="overlay"
    :key="key"
    direction="up"
    :namespace="key"
    :disable-scroll="false"
    type="modal"
    :block-class="`${key} page-quick-view`"
  >
    <template #close>
      <icon-close />
    </template>

    <template #body>
      <div
        v-if="content"
        class="page-quick-view__content"
        v-html="content"
      />
      <div
        v-else
        class="page-quick-view__loading"
      >
        <icon-loading />
      </div>
    </template>
  </overlay>
</template>

<script>

/**
 * Vue: Page Quick View (page-quick-view)
 * -----------------------------------------------------------------------------
 * View pages in quick view modal.
 *
 * @param {String} title - Title to be handleized and used for classes and keys.
 * @param {String} page - handle for page to be show in modal.
 */

import { mapActions } from 'vuex'
import Overlay from '~global/overlay/overlay'

import IconClose from '~icons/misc/close.svg'
import IconLoading from '~icons/misc/loading.svg'

export default {
  name: 'PageQuickView',

  components: {
    Overlay,
    IconClose,
    IconLoading,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      key: false,
      content: false,
    }
  },

  created() {
    this.key = this.title.toLowerCase().replace(' ', '-')
  },

  mounted() {
    this.moveModal()
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      toggleOverlay: 'overlays/toggle',
    }),

    /**
     * Open modal.
     */
    openModal() {
      if (!this.content) {
        this.queryPage()
      }

      this.toggleOverlay({
        ignoreDismissed: true,
        namespace: this.key,
      })
    },

    /**
     * Get page contents and load them into modal.
     *
     * Can't use GQL here, as page is built with sections
     * and GQL wont fetch that data.
     */
    queryPage() {
      if (!this.page) {
        return
      }

      fetch(`${window.Shopify.routes.root}pages/${this.page}`)
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser()
          const doc = parser.parseFromString(data, 'text/html')

          const content = doc.querySelector('#main-content')

          if (!content) {
            this.content = 'Page failed to load.'
          }

          this.content = content.innerHTML
        })
        .catch((error) => {
          throw new Error(error)
        })
    },

    /**
     * Move modal el to end of <body> - Resolving issues with stacking contexts.
     */
    moveModal() {
      const parent = this.$refs.overlay.$el.parentNode
      const modal = this.$refs.overlay.$el.nextSibling

      parent.removeChild(modal)

      document.body.appendChild(modal)
    },
  },
}
</script>

<style lang="scss">
@import './page-quick-view';
</style>
